module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 6
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/statisticsTemplate')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.downlStatistic),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "downlStatistic", $$v)
      },
      expression: "getUnsavedLocalSettings.download.downlStatistic"
    }
  }, _vm._l((_vm.mappedStatisticTemplates), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$l('settings/download/statisticsRename')))]), _vm._v(" "), _vm._l((_vm.mappedStatisticTemplates), function(item) {
    return _c('el-form-item', {
      key: item.value,
      staticClass: "el-form-item-full",
      attrs: {
        "label": item.value
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": _vm.$l('settings/statistics/reportSending/Name')
      },
      model: {
        value: (_vm.getUnsavedLocalSettings.download.statistics.mapping[item.value]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.download.statistics.mapping, item.value, $$v)
        },
        expression: "getUnsavedLocalSettings.download.statistics.mapping[item.value]"
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('el-row', [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/statistics/reportSending/settingsName')
    }
  }, [_c('el-row', [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px",
      "padding-bottom": "5px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "md": 1
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "success",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.addNewGroup()
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.getSettingsStatistics.allgroups), function(group) {
    return _c('el-form-item', {
      key: group,
      class: (_vm.getScreenSize > 2) ? 'statiststics-table-item-container' : ''
    }, [_c('el-row', {
      class: (_vm.getScreenSize > 2) ? 'statistics-table-item' : '',
      staticStyle: {
        "border-bottom": "1px solid rgba(0,0,0,0.2)"
      },
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 15
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Name')))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['templs' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'templs' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['templs'+group.replace('st','')]"
      }
    }, _vm._l((_vm.mappedStatisticTemplates), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "value": item.value,
          "label": item.label
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 7
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Title')))]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": _vm.$l('settings/statistics/reportSending/Title')
      },
      model: {
        value: (_vm.getSettingsStatistics['titles' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'titles' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['titles'+group.replace('st','')]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 5
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Language')))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['langs' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'langs' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['langs'+group.replace('st','')]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/english'),
        "value": "en"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/austria'),
        "value": "at"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/german'),
        "value": "de"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/french'),
        "value": "fr"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": _vm.$l('settings/interface/slovensko'),
        "value": "sl"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Duration')))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['durs' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'durs' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['durs'+group.replace('st','')]"
      }
    }, _vm._l((_vm.getSettingsStatistics.durations.split(',')), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "value": item,
          "label": _vm.$l('settings/statistics/options/' + item)
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      staticStyle: {
        "margin-top": "10px",
        "margin-bottom": "10px"
      },
      attrs: {
        "gutter": 10
      }
    }, [(_vm.getSettingsStatistics['durs' + group.replace('st', '')] == 'Range') ? _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Range')))]), _vm._v(" "), _c('div', [_c('el-input-number', {
      staticClass: "range-numbers",
      attrs: {
        "step": 1,
        "max": 31,
        "min": 1
      },
      model: {
        value: (_vm.getSettingsStatistics['ranges' + group.replace('st', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics['ranges' + group.replace('st', '')], 0, $$v)
        },
        expression: "getSettingsStatistics['ranges'+group.replace('st','')][0]"
      }
    })], 1)], 1) : _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [(_vm.getSettingsStatistics['durs' + group.replace('st', '')] == 'Range') ? _c('div', [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Range')))]), _vm._v(" "), _c('el-input-number', {
      staticClass: "range-numbers",
      attrs: {
        "step": 1,
        "max": 31,
        "min": 1
      },
      model: {
        value: (_vm.getSettingsStatistics['ranges' + group.replace('st', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics['ranges' + group.replace('st', '')], 0, $$v)
        },
        expression: "getSettingsStatistics['ranges'+group.replace('st','')][0]"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 6
      }
    }, [(_vm.getSettingsStatistics['durs' + group.replace('st', '')] != 'On Event') ? _c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Hours')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsStatistics['durs' + group.replace('st', '')] != 'On Event') ? _c('el-time-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "picker-options": {
          start: '00:00',
          step: '01:00',
          end: '24:00'
        },
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['hours' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'hours' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['hours'+group.replace('st','')]"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 24,
        "lg": 8
      }
    }, [_c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Email')))]), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": _vm.$l('settings/statistics/reportSending/Email')
      },
      model: {
        value: (_vm.getSettingsStatistics['recps' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'recps' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['recps'+group.replace('st','')]"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-bottom": "10px",
        "padding": "0px"
      },
      attrs: {
        "lg": 9
      }
    }, [_c('el-col', {
      attrs: {
        "md": 24
      }
    }, [(_vm.getSettingsStatistics['durs' + group.replace('st', '')] != 'On Event') ? _c('el-col', [_vm._v(_vm._s(_vm.$l('settings/statistics/reportSending/Days')))]) : _vm._e(), _vm._v(" "), (_vm.getSettingsStatistics['durs' + group.replace('st', '')] != 'On Event') ? _c('el-select', {
      attrs: {
        "multiple": "",
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsStatistics['dayss' + group.replace('st', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsStatistics, 'dayss' + group.replace('st', ''), $$v)
        },
        expression: "getSettingsStatistics['dayss'+group.replace('st','')]"
      }
    }, _vm._l((_vm.weekDays), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', [_c('div', {
      staticClass: "delete-button-absolute",
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_c('el-button', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "size": "small",
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.alertGroupDeleted(group)
        }
      }
    })], 1)])], 1)], 1)
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25fba982","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Statistics.vue
// module id = 448
// module chunks = 1